module.exports = __webpack_public_path__ + "static/media/trees.491c322b.svg";